/* HEDO — reveal promo widgets after the product title + price (TEST theme, 2026-10-09)
   Mobile product pages only. Hides the Shopify Forms "10% OFF" teaser and the
   Smile.io Rewards launcher while the title/price area is on screen, and shows
   them once the shopper has scrolled past it (hidden again on scrolling back up).
   Hiding uses visibility/opacity only — the apps keep running, nothing is removed,
   and the accessibility button is never touched. Fails safe to "visible". */
(function () {
  var root = document.documentElement;
  var mq = window.matchMedia('(max-width: 749px)');
  window.__hedoPromoReady = true;

  function setShown(show) {
    root.style.setProperty('--hedo-promo-vis', show ? 'visible' : 'hidden');
    root.style.setProperty('--hedo-promo-op', show ? '1' : '0');
    root.classList.toggle('hedo-promos-hidden', !show);
  }

  // 10% OFF teaser lives in a shadow root: give it a rule that follows the variables
  var SHADOW_CSS =
    "[class*='_appEmbedRootTeaser']{visibility:var(--hedo-promo-vis,visible);opacity:var(--hedo-promo-op,1);transition:opacity .25s ease,visibility .25s}";
  var sheet = null;
  try {
    sheet = new CSSStyleSheet();
    sheet.replaceSync(SHADOW_CSS);
  } catch (e) {
    sheet = null;
  }
  function patch() {
    var hosts = document.querySelectorAll('shopify-forms-embed');
    for (var i = 0; i < hosts.length; i++) {
      var sr = hosts[i].shadowRoot;
      if (!sr || sr.__hedoPromo) continue;
      try {
        if (sheet && 'adoptedStyleSheets' in sr) {
          sr.adoptedStyleSheets = sr.adoptedStyleSheets.concat([sheet]);
        } else {
          var s = document.createElement('style');
          s.textContent = SHADOW_CSS;
          sr.appendChild(s);
        }
        sr.__hedoPromo = true;
      } catch (e) {}
    }
  }

  var info = document.querySelector('product-info[id^="MainProduct-"]') || document.querySelector('product-info');
  var marker = info && (info.querySelector('[id^="price-"]') || info.querySelector('.price') || info.querySelector('h1'));

  if (!mq.matches || !marker) {
    setShown(true);
    return;
  }

  // "passed" = the bottom of the price block has scrolled up behind the header strip.
  // Position-based (not IntersectionObserver), so a jump from the top straight
  // past the price is caught too.
  var raf = 0;
  function check() {
    raf = 0;
    // if the price is hidden (e.g. unavailable variant) fall back to the title
    var el = marker.offsetHeight ? marker : info.querySelector('h1') || marker;
    var passed = el.getBoundingClientRect().bottom < 60;
    setShown(!mq.matches || passed);
  }
  function schedule() {
    if (!raf) raf = requestAnimationFrame(check);
  }
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  if (mq.addEventListener) mq.addEventListener('change', schedule);
  check();

  patch();
  new MutationObserver(patch).observe(document.body, { childList: true });
  var n = 0;
  var t = setInterval(function () {
    patch();
    if (++n > 20) clearInterval(t);
  }, 500);
})();
